export enum SortType {
    newestFirst = "Newest First",
    oldestFirst = "Oldest First",
    az = "A-Z",
    za = "Z-A"
}
